<div class="history-page">

  <!-- HEADER -->
  <div class="header">

    <div>

      <p class="mini-title">
        INVENTORY HISTORY
      </p>

      <h1>
        Purchase History
      </h1>

      <span>
        Track supplier purchases and stock updates
      </span>

    </div>

  </div>

  <!-- FILTER -->
  <div class="filter-bar">

    <input
      type="text"
      placeholder="Search supplier..."
      [(ngModel)]="searchText"
      (input)="search()"
    />

  </div>

<!-- SUMMARY -->
<div class="summary-grid">

  <div class="summary-card purchase">

    <p>{{ t('totalPurchase') }}</p>

    <h2>
      {{ totalPurchase | number | bnNumber:'৳ ' }}
    </h2>

  </div>

  <div class="summary-card profit">

    <p>{{ t('expectedProfit') }}</p>

    <h2>
      {{ totalProfit | number | bnNumber:'৳ ' }}
    </h2>

  </div>

  <div class="summary-card due">

    <p>{{ t('supplierDue') }}</p>

    <h2>
      {{ totalDue | number | bnNumber:'৳ ' }}
    </h2>

  </div>

</div>

  <!-- EMPTY -->
  <div
    class="empty"
    *ngIf="!loading && filteredPurchases.length === 0"
  >
    No purchase history found
  </div>

  <!-- PURCHASE -->
  <div
    class="purchase-card"
    *ngFor="let p of filteredPurchases"
  >

    <!-- TOP -->
    <div class="card-top">

      <div>

        <h3>
          {{ p.supplierName }}
        </h3>

        <div class="meta">

          <span>
            📞 {{ p.supplierContact }}
          </span>

          <span>
            📅 {{ p.createdAt | date:'medium' }}
          </span>

        </div>

      </div>

      <button
        class="delete-btn"
        (click)="deletePurchase(p.id)"
      >
        Delete
      </button>

    </div>

    <!-- TABLE -->
    <div class="table-wrapper">

      <table>

        <thead>

          <tr>

            <th>Product</th>
            <th>Qty</th>
            <th>Buy</th>
            <th>Sell</th>
            <th>Profit</th>
            <th>Stock</th>

          </tr>

        </thead>

        <tbody>

          <tr
            *ngFor="let item of p.items"
          >

            <td>
              {{ item.productName }}
            </td>

            <td>
              {{ item.quantity | bnNumber }}
            </td>

            <td>
              {{ item.unitPrice | bnNumber:'৳ ' }}
            </td>

            <td>
              {{ item.sellPrice | bnNumber:'৳ ' }}
            </td>

            <td class="profit-text">

              {{
                ((item.sellPrice - item.unitPrice) * item.quantity)
                | bnNumber:'৳ '
              }}

            </td>

            <td>
              {{ item.stock | bnNumber }}
            </td>

          </tr>

        </tbody>

      </table>

    </div>

  <!-- FOOTER -->
<div class="footer">

  <div class="invoice">
    {{ t('total') }}
  </div>

  <div class="amount">
    {{ p.totalAmount | number | bnNumber:'৳ ' }}
  </div>

  <div class="invoice due-label">
    {{ t('paidAmountLabel') }}
  </div>

  <div class="amount paid-amount">
    {{ (p.paidAmount || 0) | number | bnNumber:'৳ ' }}
  </div>

  <div class="invoice due-label">
    {{ t('due') }}
  </div>

  <div class="amount due-amount">
    {{
      (
        (p.totalAmount || 0)
        -
        (p.paidAmount || 0)
      )
      | number
      | bnNumber:'৳ '
    }}
  </div>

</div>

  </div>

</div>